import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {SearchControlsComponent} from '@aviary/components/search/search-controls/search-controls.component';
import {CATALOG_SEARCH_QUERY_TYPES} from '@store/catalog/catalog.types';
import {Store} from '@ngrx/store';
import {RouterActions} from '@store/aviary/aviary.adapter';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {QueryTypeUpdate} from '@aviary/components/search/search.types';

@Component({
  selector: 'px-catalog-header',
  host: {
    class: 'flex w-full gap-10 justify-items-center'
  },
  template: `
    @if ({
      isMdOrAbove: viewportSelectors.isMdAndUp | select
    }; as vm) {
      <div class="flex flex-col gap-4 md:gap-5 px-catalog-header w-full h-full bg-no-repeat bg-cover bg-center items-center justify-items-center p-4 md:p-6">
        <div class="flex flex-col gap-0">
          <p class="text-center text-display-small lg:text-display-medium">Search the Catalog</p>
          <p class="text-center text-title-medium lg:text-headline-small">or explore our featured collections!</p>
        </div>
        <mx-search-controls [queryTypes]="CATALOG_SEARCH_QUERY_TYPES" (queryTypeChange)="onQueryTypeChange($event)" (searchSubmit)="onSearchSubmit($event)"
                            [placeholderText]="vm.isMdOrAbove ? 'Enter search term here...' : 'Search for...'" typeParamNameOverride="searchTarget"
                            [showDropShadows]="false" [showBorder]="true" [hasMinWidth]="false" class="my-4 md:my-5 md:max-w-[42.5rem]"/>
      </div>
    }
  `,
  styles: `
      .px-catalog-header {
          background: linear-gradient(0deg, rgba(224, 228, 221, 0.85) 0%, rgba(224, 228, 221, 0.85) 100%), url("/assets/search_block_bg.jpg");
      }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SearchControlsComponent, SelectPipe]
})
export class CatalogHeaderComponent {
  public readonly CATALOG_SEARCH_QUERY_TYPES = CATALOG_SEARCH_QUERY_TYPES;
  public readonly viewportSelectors = ViewportSelectors;
  private readonly store = inject(Store);
  private query: string;
  private queryType: string;

  public onQueryTypeChange(queryTypeUpdate: QueryTypeUpdate): void {
    this.queryType = queryTypeUpdate.queryType;
    if (this.query) this.search();
  }

  public onSearchSubmit(query: string): void {
    this.query = query;
    this.search();
  }

  private search(): void {
    this.store.dispatch(RouterActions.updateSearchParams(this.query, this.queryType, 'CATALOG_SEARCH', 'searchTarget'));
  }
}
